import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { NavLink } from 'react-router'

class Header extends React.Component {
  render() {
    return (
      <div className="header-container">
        <div className="header" id="header">
          <nav>
            <div className="header-logo">
              <AnchorLink href="#root">
                <img src="pngs/leaf.jpg" alt="" />
                <div className="title">
                  <span>中町内科</span>
                  <span>医院</span>
                </div>
              </AnchorLink>
            </div>
            <ul id="menu-list" className="on">
              <li href="">
                <NavLink to="/~naka-hp/#introduction">診療科</NavLink>
              </li>
              <li href="">
                <NavLink to="/~naka-hp/#schedule">診察日＆時間</NavLink>
              </li>
              <li href="">
                <NavLink to="/~naka-hp/#access">アクセス</NavLink>
              </li>
              <li href="">
                <NavLink to="/~naka-hp/#contact">お問い合わせ</NavLink>
              </li>
              <li>
                <NavLink to="/~naka-hp/notice">院内掲示</NavLink>
              </li>

              <li>
                <NavLink to="/~naka-hp/criterion">施設基準</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}

export default Header

